import request from "@/utils/request";
function init (router) {
    // 以下路径用到其他公众号（请保证key路由唯一）
    const url = {
        // '/landing/index':{type:'妙小程人工智能体验馆',remark:'妙小程人工智能体验馆'},  //新公众号无法支付 受影响了
        '/subscribe':{type:'妙小程人工智能体验馆',remark:'妙小程人工智能体验馆'},
    }
    router.beforeEach((to, from, next) => {
        // 当前是否是主公众号
        const fromisMain = !url[from.path] // || (url[from.path].page !== currentPage)
        //目的页是否是主公众号
        const toisMain = !url[to.path] // || (url[to.path].page !== currentPage)

        // 当前是非主号
        if(!fromisMain) {
            if(!toisMain) { // 非主号到非主号
                if(url[to.path].type !== url[from.path].type) weixinConfig(url[to.path].type)    
            } else {    // 非主号到主号
                weixinConfig('MAIN')    
            }
        } else {  //当前是主号
            //主号到别的号
            if(!toisMain) {
                weixinConfig(url[to.path].type)    
            } else if(toisMain && from.path==='/') {
                weixinConfig('MAIN')    
            }
        }
        next()
    })
}   

// 配合全局路由守卫
async function weixinConfig(type='MAIN') {
    console.log("——————————————————————执行了wx.config",type)
    const isFlow = /\/(flow|recommend|entrance)\//.test(window.location.href);
    const url = process.env.VUE_APP_SERVER_URL;

    try {
        let res = {}
        if( type==='MAIN') {
            //主号和以前不知道啥公众号来的
            res = await request.get( isFlow ? `${url}/wxin/getFcSign` : `${url}/wxin/getSign`, { params: { url: window.location.href } })
        } else {
            //其他公众号，比如【正式：妙小程人工智能体验馆，测试：妙小程工作平台】
            res = await request.get( `${process.env.CRM3_URL}/crm-weixin/weixin/MXC_INTELLIGENCE/getSign`, { params: { url: window.location.href } })
        }
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见附录1
            openTagList: ["wx-open-launch-weapp","wx-open-subscribe"],
            jsApiList: [
                "checkJsApi",
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareWeibo",
                "onMenuShareQZone",
                "getLocation",
                "getNetworkType"
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
    } catch (err) {
        console.log("微信初始化失败", err);
    }
}
export default init



// WEBPACK FOOTER //
// ./src/utils/wx-config.js